export const testComment =  {
  type: 0, // 发表评论的类型，必填,发评论时，值为0，回复评论时，值为1
  item_id: '123123123', // 文章id,必填
  comment_ref_id: '', // 文章评论映射唯一标识，必填
  comment_id: ``, // 回复评论的id,回复时需要带上
  message: 'very good opinion.', // 用户评论，必填
  user_id: '123123', // 用户id，非必填
  service_ticket: 'xxx', // 非必填
  people_id: 'xxxx', // 自媒体人id
  user_image: 'uclocal://avatar_05.png', // 用户头像，非必填(二期如果用户选了头像，返回所选头像。格式: uclocal://123.png，其中uclocal://代表本地文件，123.png代表本地文件名，用于映射线上文件)
  user_name: '', // 用户名，非必填
  user_mobile: '', // 用户手机号，非必填
  city: '', // 用户所在城市(二期)
  province: '', // 用户所在省份(二期)
  nation: '', // 用户所在国家(二期)
  post_count: 1, // 用户当天评论发表次数（1.5.4)
  is_send_comment: true, // 是否向架构提交本次 comment，默认 true
  is_send_repost: false, // 是否需要转发，默认 false
  image: [{ // 用户评论携带的图片地址数组
    id: 123,
    src: 'http://img.ucweb.com/s/uae/g/1s/test/height.png?id=gf213123213213&type=src&w=544&h=862',
    thumb_url: 'http://img.ucweb.com/s/uae/g/1s/test/height.png?id=gf213123213213&type=src&w=544&h=862',
  }],
};
